<script setup lang="ts">
import {
  computed,
} from 'vue';

import type { IFormPlainDataListboxPropsChangeState } from '@modules/forms/types';
import type {
  ISettingsViewAllStatisticsPayload,
} from '@modules/general-settings/submodules/full-stats-access/types';
import VCard from '@components/card/VCard/VCard.vue';
import VLoader from '@components/loader/VLoader.vue';
import VFormPlainDataListbox from '@modules/forms/components/inputs/VFormPlainDataListbox/VFormPlainDataListbox.vue';
import {
  TRANSLATION_GROUP_GENERAL_SETTINGS_FULL_STATS_ACCESS,
} from '@modules/general-settings/submodules/full-stats-access/constants';
import {
  useSettingsFullStatsAccessAddMutation,
  useSettingsFullStatsAccessRemoveMutation,
} from '@modules/general-settings/submodules/full-stats-access/mutations';
import useSettingsFullStatsAccessListQuery
  from '@modules/general-settings/submodules/full-stats-access/queries/useSettingsFullStatsAccessListQuery';

const { data, isLoading } = useSettingsFullStatsAccessListQuery();
const { mutateAsync: addField, isLoading: isAddFieldLoading } = useSettingsFullStatsAccessAddMutation();
const { mutateAsync: removeField, isLoading: isRemoveFieldLoading } = useSettingsFullStatsAccessRemoveMutation();

const options = computed(() => data.value?.map((a) => ({ ...a, id: a.id.toString() })) ?? []);

function onChange(state: IFormPlainDataListboxPropsChangeState<string>): void {
  const { check, values, ...admins_with_full_stats_access } = state;

  const payloadObject: ISettingsViewAllStatisticsPayload = {
    admins_with_full_stats_access,
  };

  if (check) {
    void addField(payloadObject);
  } else {
    void removeField(payloadObject);
  }
}
</script>

<template>
  <VCard v-data-qa-auto-id="'AdminGeneralSettingsFullStatsAccessPage'">
    <VLoader
      :loading="isLoading"
      min-height="350px"
    >
      <VFormPlainDataListbox
        :label="$getTranslation(TRANSLATION_GROUP_GENERAL_SETTINGS_FULL_STATS_ACCESS, 'LABEL')"
        :data="options"
        :disabled="isAddFieldLoading || isRemoveFieldLoading"
        @change="onChange"
      />
    </VLoader>
  </VCard>
</template>
